// components/CenteredLoader.jsx
import styles from "./CenteredLoader.module.css";

export default function CenteredLoader({ message = "Processing..." }) {
  return (
    <div className={styles.loaderOverlay}>
      <div className={styles.loaderBox}>
        <div className={styles.spinner} />
        <div className={styles.loaderText}>{message}</div>
      </div>
    </div>
  );
}
